// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1PAzw","footer":"ChangeClinic_footer__22PYL"};